(() => {
  const hub = document.querySelector('[data-lovely-link-hub]');
  if (!hub || hub.dataset.trackingReady === 'true') return;
  hub.dataset.trackingReady = 'true';

  hub.addEventListener('click', (event) => {
    const link = event.target.closest('[data-link-hub-item]');
    if (!link) return;

    const eventData = {
      event: 'lovely_store_ig_hub_click',
      destination_label: link.dataset.linkLabel || '',
      destination_url: link.href,
      destination_type: link.dataset.linkType || 'link',
      page_path: window.location.pathname,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('lovely_store_ig_hub_click', {
        destination_label: eventData.destination_label,
        destination_url: eventData.destination_url,
        destination_type: eventData.destination_type,
        page_path: eventData.page_path,
      });
    }

    document.dispatchEvent(
      new CustomEvent('lovely:store-ig-hub-clicked', { detail: eventData })
    );
  });
})();
